import { ANALYSIS_GROUPT_TYPE_MAP } from '@Bill/constants'
import {
  getNameDescriptionTableColumn,
  getEnabledTableColumn,
  getProjectTableColumn,
  getStatusTableColumn,
} from '@/utils/common/tableColumn'
import {
  getTimeRangeTableColumn,
  getThresholdTableColumn,
  getAlarmGroupsTableColumn,
  getViewScopeTableColumn,
} from '../utils'
export default {
  data () {
    return {
      columns: [],
    }
  },
  created () {
    this.columns = [
      getNameDescriptionTableColumn({
        onManager: this.onManager,
        hideField: true,
        formRules: [{
          required: true,
          max: 256,
          message: this.$t('validator.maxLength', ['256']),
        }],
        slotCallback: row => {
          return (
            <side-page-trigger onTrigger={() => this.handleOpenSidepage(row)}>{row.name}</side-page-trigger>
          )
        },
      }),
      getStatusTableColumn({ statusModule: 'analysisAlarm' }),
      getAlarmGroupsTableColumn(),
      getProjectTableColumn({ title: this.$t('monitor.text00015') }),
      getViewScopeTableColumn(),
      getTimeRangeTableColumn(),
      getThresholdTableColumn(),
      getEnabledTableColumn(),
      {
        field: 'day_record_count',
        title: this.$t('bill.day_record_count'),
        sortable: true,
        sortBy: 'day_record_count',
        formatter: ({ row }) => {
          return row.day_record_count || '0'
        },
        slots: {
          default: ({ row }) => {
            return [
              <div>
                <span style={{ color: row.day_record_count > 0 ? 'red !important' : '#606266' }}>{row.day_record_count || '0'}</span>
              </div>,
            ]
          },
        },
      },
      {
        field: 'month_record_count',
        title: this.$t('bill.month_record_count'),
        sortable: true,
        sortBy: 'month_record_count',
        formatter: ({ row }) => {
          return row.month_record_count || '0'
        },
      },
    ]
  },
  methods: {
    getLabel (key) {
      return ANALYSIS_GROUPT_TYPE_MAP[key]?.value || this.$t(ANALYSIS_GROUPT_TYPE_MAP[key]?.t)
    },
  },
}
